import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

const ServiceAlertTable = ({ otherServiceAlert, columns }) => {
  // const formattedServiceAlert = otherServiceAlert?.map((booking) => ({
  //   ...booking,
  //   booked_at: booking.booked_at ? new Date(booking.booked_at).toLocaleString("en-GB", {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: true, 
  //   }) : "",
  // }));
  

  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: { xs: 650, sm: 682, lg: 1350 },
        bgcolor: "background.paper",
      }}
    >
      <DataGrid
        rows={otherServiceAlert}
        columns={columns}
        disableSelectionOnClick
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
      />
    </Box>
  );
};

export default ServiceAlertTable;
